import { render, staticRenderFns } from "./VideoModal.vue?vue&type=template&id=15680c9e&scoped=true"
import script from "./VideoModal.vue?vue&type=script&lang=js"
export * from "./VideoModal.vue?vue&type=script&lang=js"
import style0 from "./VideoModal.vue?vue&type=style&index=0&id=15680c9e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15680c9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15680c9e')) {
      api.createRecord('15680c9e', component.options)
    } else {
      api.reload('15680c9e', component.options)
    }
    module.hot.accept("./VideoModal.vue?vue&type=template&id=15680c9e&scoped=true", function () {
      api.rerender('15680c9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/AppPage/HundredDayOathDetail/components/VideoModal.vue"
export default component.exports